import theme from '@styles/theme';
export default {
  button: {
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
    height: '56px',
    width: '100%',
    padding: '16px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    backgroundColor: 'transparent',
    color: theme.rawColors.neutralBlack,
    '.button-children-wrapper': {
      width: '100%',
      justifyContent: 'space-between',
      textAlign: 'left'
    },
    '&:last-of-type': {
      borderBottom: `1px solid ${theme.rawColors.lightGrey300}`
    }
  }
};